import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LIKE_DISLIKE_PAIR, SET_BROWSER_HISTORY } from "../store/types/menuBar";
import { CHANGE_FONT, IS_FONT_LOADING } from "../store/types/font";
import { generateRandomNumber } from "../utils";
import { deleteUser, putFonts } from "../utils/Fonts";

export const dispatchRandFontPair = ({
  fonts,
  fontDescriptionLock,
  fontHeadingLock,
  dispatch,
  currentFontPair,
  allPairs,
  isBrowserHistoryActive
}) => {
  if (allPairs.length === 0) return;
  if (isBrowserHistoryActive)
    dispatch({ type: SET_BROWSER_HISTORY, payload: false });
  const link1randomIndex = generateRandomNumber(allPairs);
  let link2randomIndex = generateRandomNumber(allPairs);

  if (link1randomIndex === link2randomIndex)
    link2randomIndex =
      typeof fonts[link2randomIndex] === "undefined" ||
      link2randomIndex === fonts.length
        ? link2randomIndex - 1
        : link2randomIndex + 1;
  let temp = [];
  let anchor;
  let body;
  switch (true) {


    case !fontDescriptionLock && !fontHeadingLock:
      dispatch({
        type: CHANGE_FONT,
        payload: [
          allPairs[link1randomIndex].likedPair[2],
          allPairs[link1randomIndex].likedPair[3],
        ],
      });
      break;

    case !fontDescriptionLock:
      temp = [];
      for (let index = 0; index < allPairs.length; index++) {
          if((allPairs[index].likedPair[2] === currentFontPair[0]) && (allPairs[index].likedPair[3] !== currentFontPair[1])){   // avoid same pair push
            temp.push(allPairs[index])
          }
      }

      if(temp.length >0){
        let randomIndex = generateRandomNumber(temp);
        anchor =  temp[randomIndex].likedPair[2]
        body = temp[randomIndex].likedPair[3]

      }else{
        anchor = currentFontPair[0]
        body = currentFontPair[1]
      }
      
      dispatch({
        type: CHANGE_FONT,
        payload: [
          anchor,
          body
        ],
      });
      break;

    case !fontHeadingLock:
      temp = [];
      for (let index = 0; index < allPairs.length; index++) {
          if((allPairs[index].likedPair[3] === currentFontPair[1]) && (allPairs[index].likedPair[2] !== currentFontPair[0])){   // avoid same pair push
            temp.push(allPairs[index])

          }
      }
      if(temp.length >0){
        let randomIndex = generateRandomNumber(temp);
        anchor =  temp[randomIndex].likedPair[2]
        body = temp[randomIndex].likedPair[3]

      }else{
        anchor = currentFontPair[0]
        body = currentFontPair[1]
      }

      dispatch({
        type: CHANGE_FONT,
        payload: [
          anchor,
          body
        ],
      });
      break;
  }
};

export const useKeyDown = ({
  likedPair,
  setLikedPair,
  showPairSec,
  setLoader,
}) => {
  const dispatch = useDispatch();
  const {
    disableKeyDown,
    fontHeadingLock,
    fontDescriptionLock,
    currentFontPair,
    fonts,
    allPairs
  } = useSelector((state) => state.font);

  const generateRandomFontPair = useCallback(
    (dispatch) => {
      dispatchRandFontPair({
        dispatch,
        fontHeadingLock,
        fontDescriptionLock,
        currentFontPair,
        fonts,
        allPairs
      });
    },
    [currentFontPair, fontDescriptionLock, fontHeadingLock, fonts]
  );

  const keyDownEventHandler = useCallback(
    async (event) => {
      const dislikedPairs = !localStorage.getItem("dislikedPairs")
        ? []
        : JSON.parse(localStorage.getItem("dislikedPairs")).dislikedPairs;
      const indexofLikedPair =
        likedPair &&
        Array.isArray(likedPair) &&
        likedPair?.findIndex(
          (item) => item?.likedPair?.toString() === currentFontPair?.toString()
        );

      const indexofDisLikedPair =
        dislikedPairs &&
        Array.isArray(dislikedPairs) &&
        dislikedPairs?.findIndex(
          (item) =>
            item?.dislikedPair?.toString() === currentFontPair?.toString()
        );

      if (event.key === "l" || event.key === "L") {
        if (indexofLikedPair !== -1) {
          const oldLikedPair = Array.isArray(likedPair) ? likedPair : [];
          const filterArray = likedPair?.filter(
            (item) =>
              item?.likedPair?.toString() !== currentFontPair?.toString()
          );
          const { success } = await deleteUser({ likedPairs: filterArray });
          if (!success) {
            setLikedPair(oldLikedPair);
            return;
          }
          setLikedPair(filterArray);
        }

        const payload = {
          dislikedPairs: dislikedPairs?.filter(
            (item) =>
              item?.dislikedPair?.toString() !== currentFontPair?.toString()
          ),
        };
        localStorage.setItem("dislikedPairs", JSON.stringify(payload));

        if (
          indexofLikedPair === -1 ||
          typeof indexofLikedPair === "undefined"
        ) {
          setLikedPair(await putFonts(currentFontPair,payload.dislikedPairs))
        }
      }
      if (event.key === "d" || event.key === "D") {
        const disliked = { dislikedPair: currentFontPair };
        if (indexofDisLikedPair !== -1) {
          const payload = {
            dislikedPairs: dislikedPairs?.filter(
              (item) =>
                item?.dislikedPair?.toString() !== currentFontPair?.toString()
            ),
          };
          localStorage.setItem("dislikedPairs", JSON.stringify(payload));
          deleteUser({ dislikedPairs: payload });
        }
        const payload = {
          dislikedPairs: !localStorage.getItem("dislikedPairs")
            ? [disliked]
            : [...dislikedPairs, disliked],
        };
        
        if (indexofDisLikedPair === -1)
          localStorage.setItem("dislikedPairs", JSON.stringify(payload));
        const oldLikedPair = Array.isArray(likedPair) ? likedPair : [];
        const filterArray = likedPair?.filter(
          (item) => item?.likedPair?.toString() !== currentFontPair?.toString()
        );
        setLikedPair(filterArray);
        const { success } = await deleteUser({ likedPairs: filterArray });
        if (!success) setLikedPair(oldLikedPair);
        deleteUser({ dislikedPairs: payload });
      }
      // return dispatch({ type: LIKE_DISLIKE_PAIR, payload: false });
      if (event.key === " ") {
        dispatch({ type: IS_FONT_LOADING, payload: true });
        return generateRandomFontPair(dispatch);
      }
    },
    [currentFontPair, dispatch, generateRandomFontPair, likedPair, setLikedPair]
  );

  useEffect(() => {
    if (!disableKeyDown) return;
    if (showPairSec) return;
    document.addEventListener("keydown", keyDownEventHandler);

    return () => {
      document.removeEventListener("keydown", keyDownEventHandler);
    };
  }, [keyDownEventHandler, showPairSec, disableKeyDown]);

  return;
};
